/** Types */
export const GET_VEHICLES = "GET_VEHICLES";
export const GET_VEHICLES_SUCCESS = "GET_VEHICLES_SUCCESS";
export const ADD_VEHICLE = "ADD_VEHICLE";
export const EDIT_VEHICLE = "EDIT_VEHICLE";
export const DELETE_VEHICLE = "DELETE_VEHICLE";
export const CHANGE_STATUS_VEHICLE = 'CHANGE_STATUS_VEHICLE'

export const GET_VEHICLES_IDLES = "GET_VEHICLES_IDLES";
export const GET_VEHICLES_IDLES_SUCCESS = "GET_VEHICLES_IDLES_SUCCESS";

export const GET_VEHICLES_LOCATIONS = "GET_VEHICLES_LOCATIONS";
export const GET_VEHICLES_LOCATIONS_SUCCESS = "GET_VEHICLES_LOCATIONS_SUCCESS";







